import gql from "graphql-tag";
import { DocumentNode } from "graphql";

export const SAVE_USER_OPERATION_NAME = "userService_saveUser";
export const SAVE_USER: DocumentNode = gql`mutation saveUser($params:SaveParams_LongInput) {
  userService_saveUser(params:$params) {
      id notificationMessage
    }
  }`;
